import React from 'react';
import { motion } from 'framer-motion';
import { hcfCycle } from '../data/pillars';
import { ResearchStatusNote } from './pillars/ResearchStatusNote';
import { fadeUp } from '../utils/motion';

/** The general HCF cycle: how development moves. */
export function OperatingModel() {
  return <section id="hcf-cycle" className="scroll-mt-20 py-20 lg:py-24 bg-surface-bg border-y border-line" data-id="element-1055" data-mp="lgwlhtqo0xzi">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1056" data-mp="1i7f7arlitwps">
        <motion.div {...fadeUp} className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-16 mb-12" data-id="element-1057" data-mp="1i8qcmvum7cj0">
          <div className="lg:col-span-5" data-id="element-1058" data-mp="1da5c0vbgaqu1">
            <p className="text-sm font-medium text-teal mb-3" data-id="element-1059" data-mp="18gatvwbhujx2">The HCF cycle</p>
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark leading-tight" data-id="element-1060" data-mp="14fqvyqj3jc9v">
              Assess → Review → Develop → Reassess
            </h2>
          </div>
          <p className="lg:col-span-7 lg:pt-8 text-lg text-ink-muted leading-relaxed" data-id="element-1061" data-mp="1w6optxx792wx">
            The Human Capability Framework connects structured exercises, transparent assessment criteria, human
            review and development activities. Every finding leads somewhere: to review, to practice, and to a
            later reassessment.
          </p>
        </motion.div>

        <motion.ol {...fadeUp} aria-label="HCF cycle" className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-line border border-line rounded-lg overflow-hidden" data-id="element-1062" data-mp="tibkgncmhj3o">
          {hcfCycle.map((item, index) => <li key={item.step} className="bg-white p-6 lg:p-8" data-id="element-1063" data-mp="pjubdy9n5yjm" data-mpi={index}>
              <span className="block font-heading font-bold text-sm text-teal mb-2" data-id="element-1064" data-mp="aljvpyebabs8">{index + 1}</span>
              <span className="block font-heading font-bold text-2xl text-ink-dark" data-id="element-1065" data-mp="fkd81nhv3wqt">{item.step}</span>
              <span className="mt-2 block text-ink-muted leading-relaxed" data-id="element-1066" data-mp="24zt5i5mfbu0v">{item.description}</span>
            </li>)}
        </motion.ol>

        <ResearchStatusNote className="mt-12 max-w-3xl" data-id="element-1067" data-mp="29y4eke4wa0i1" />
      </div>
    </section>;
}